import lodash from 'lodash';
import * as Sqrl from 'squirrelly';
import { toList } from '../utils/toList.esm.js';
import { LOCATION_VALIDATION_ERROR_22Q112_DIGEORGE_UNSUPPORTED, LOCATION_VALIDATION_ERROR_ALL_MICRODELETION_ADD_ONS_REQUIRED, LOCATION_VALIDATION_ERROR_FETAL_SEX_ADD_ON_DISALLOWED_SINGLETON, LOCATION_VALIDATION_ERROR_FETAL_SEX_ADD_ON_DISALLOWED_TWIN, LOCATION_VALIDATION_ERROR_FETAL_SEX_ADD_ON_REQUIRED, LOCATION_VALIDATION_ERROR_UNKNOWN } from './postProcessingActions.models.esm.js';

var _a;
var LOCATION_ERROR_TO_INVALID_TEST_MAPPING = (_a = {},
    // NY/IL
    _a[LOCATION_VALIDATION_ERROR_22Q112_DIGEORGE_UNSUPPORTED] = {
        invalidTestCategory: 'Invitae Singleton NIPS',
        invalidTestNames: ['Add-on Microdeletion (22q11.2 deletion)'],
        replacement: 'Add-on Microdeletions (22q11.2 deletion, 1p36 deletion, Prader-Willi/Angelman, Cri-du-chat, Wolf-Hirschhorn)',
    },
    _a[LOCATION_VALIDATION_ERROR_ALL_MICRODELETION_ADD_ONS_REQUIRED] = {
        invalidTestCategory: 'Invitae Singleton NIPS',
        invalidTestNames: ['Customized microdeletion panel'],
        replacement: 'Add-on Microdeletions (22q11.2 deletion, 1p36 deletion, Prader-Willi/Angelman, Cri-du-chat, Wolf-Hirschhorn)',
    },
    _a[LOCATION_VALIDATION_ERROR_FETAL_SEX_ADD_ON_DISALLOWED_SINGLETON] = {
        invalidTestCategory: 'Invitae Singleton NIPS',
        invalidTestNames: ['Add-on Sex Chromosome Aneuploidies (WILL report fetal sex)'],
        replacement: 'Add-on Sex Chromosome Aneuploidies (will NOT report fetal sex)',
    },
    // CN/IN
    _a[LOCATION_VALIDATION_ERROR_FETAL_SEX_ADD_ON_DISALLOWED_TWIN] = {
        invalidTestCategory: 'Invitae Twin NIPS',
        invalidTestNames: ['Add-on Y Chromosome (to predict fetal sex)'],
    },
    _a[LOCATION_VALIDATION_ERROR_FETAL_SEX_ADD_ON_REQUIRED] = {
        invalidTestCategory: 'Invitae Singleton NIPS',
        invalidTestNames: ['Add-on Sex Chromosome Aneuploidies (will NOT report fetal sex)'],
        replacement: 'Add-on Sex Chromosome Aneuploidies (WILL report fetal sex)',
    },
    _a[LOCATION_VALIDATION_ERROR_UNKNOWN] = {
        customErrorMessage: 'This test selection can’t be ordered in your location. Please contact Invitae Client Services with questions about test selection availability for your location.',
        invalidTestCategory: '',
        invalidTestNames: [],
    },
    _a);
var getDefaultInvalidTest = function (errorType) { return ({
    invalidTestCategory: '',
    invalidTestNames: ["Unhandled location validation error: ".concat(errorType)],
}); };
var getLocationValidationReplacements = function (locationValidationErrorTypes) {
    return locationValidationErrorTypes.map(function (locationValidationErrorType) {
        return LOCATION_ERROR_TO_INVALID_TEST_MAPPING[locationValidationErrorType] ||
            getDefaultInvalidTest(locationValidationErrorType);
    });
};
var processLocationValidationError = function (initialContent, postProcessingParameters) {
    var errorTypes = postProcessingParameters === null || postProcessingParameters === void 0 ? void 0 : postProcessingParameters.errorTypes;
    if (!errorTypes) {
        return initialContent;
    }
    var invalidTests = getLocationValidationReplacements(errorTypes);
    // get unique invalid test categories, names and replacements to display
    var uniqueInvalidTestNames = lodash.flatten(Array.from(new Set(invalidTests.map(function (it) { return it.invalidTestNames; }))));
    var uniqueInvalidTestCategories = Array.from(new Set(invalidTests.map(function (it) { return it.invalidTestCategory; })));
    var uniqueInvalidTestReplacements = Array.from(new Set(invalidTests.map(function (it) { return it.replacement; }).filter(function (r) { return r; })));
    var customErrorMessage = invalidTests.map(function (it) { return it.customErrorMessage; }).filter(function (m) { return m; })[0];
    return Sqrl.render(initialContent, {
        article: uniqueInvalidTestNames.length > 1 ? 'them' : 'it',
        categories: toList(uniqueInvalidTestCategories),
        customErrorMessage: customErrorMessage,
        replacements: toList(uniqueInvalidTestReplacements),
        testNames: toList(uniqueInvalidTestNames),
    });
};

export { LOCATION_ERROR_TO_INVALID_TEST_MAPPING, getDefaultInvalidTest, getLocationValidationReplacements, processLocationValidationError };
//# sourceMappingURL=processLocationValidationError.esm.js.map
